var I18n_en = {
  languages_name : {
    fr : "French",
    eu : "Basque",
    es : "Spanish",
    en: "English"
  },
  tuto : {
    next: "NEXT",
    page1_title : "Informations",
    page1_subtitle : "Be kept better informed on sea conditions and local weather",
    page1_description : "Flag colour, local weather, sea conditions: find all the practical information you need for the bathing areas in the Pays Basque Community.",
    page2_title : "Your app",
    page2_subtitle : "Personalise the app by selecting your favourite beaches ",
    page2_description : "Personalise the app by selecting your favourite beaches so that you follow any changes in the conditions of your bathing areas.",
    page3_title : "Thanks to them !",
    page3_subtitle : "This project was co-funded by the European Union.",
    page3_description : "Europe is actively engaged in the Nouvelle Aquitaine region through the European Fund for Regional Development.",
  },
  flag_explanations : {
    explanation_0 : "Unsupervised beach",
    explanation_1 : "Supervised swimming with no apparent danger",
    explanation_2 : "Supervised swimming with moderate or considerable danger",
    explanation_3 : "Swimming prohibited",
    explanation_31 : "Swimming prohibited",
    explanation_32 : "Swimming prohibited\nPoor weather conditions",
    explanation_33 : "Swimming prohibited\nDangerous swimming conditions (swell, current)",
    explanation_34 : "Swimming prohibited\nJellyfish",
    explanation_35 : "Swimming prohibited\nPollution (floating waste, etc.)",
    explanation_36 : "Swimming prohibited\nEvent",
    explanation_37 : "Swimming prohibited\nLife saving operation in progress",
    explanation_38 : "Swimming prohibited\nOstreopsis Algae in the bathing area",
    explanation_4 : "Swimming prohibited\nTemporary drop in water quality. ",
    explanation_5 : "Unsupervised swimming",
    //TODO : A AJOUTER DANS LES AUTRES LANGUES !!!!!!
    explanation_6: 'Ocean lookout',
    //EO TODO
    explanation_null : "",
    conform_quality : "Quality complies with regulations",
    not_conform_quality : "No compliant quality",
    no_quality : "Quality not specified",
  },
  //TODO : A AJOUTER DANS LES AUTRES LANGUES !!!!!!
  quality_explanations: {
    explanation_1: 'Quality complies with regulations',
    explanation_3: 'Quality complies with regulations',
    explanation_2: 'No compliant quality',
    explanation_4: 'No compliant quality',
    explanation_5: 'No compliant quality',
    explanation_0: 'Quality not specified',
    explanation_51: 'Heavy rain, thunderstorms',
    explanation_52: 'Technical problem - network',
    explanation_53: 'Damage from offshore',
    explanation_54: 'River plume',
  },
  ostreopsis_explanations : {
    explanation_0: 'Ostreopsis - No risk',
    explanation_1: 'Ostreopsis - Low alert',
    explanation_2: 'Ostreopsis - Moderate alert',
    explanation_3: 'Ostreopsis - Moderate alert ',
    explanation_4: 'Ostreopsis - High alert',
  },
  alertform: {
    header_title: 'Alert',
    type: 'Type',
    localization: 'Geographic position',
    description: 'Description',
    incomplete_desc: 'Incomplete description',
    incomplete_desc_text:
      'Please define at least one type and one description (or photo) etc.',
    thanks: 'Thank you',
    classify: 'Type',
    free_description: 'Open description',
    your_info: 'Vos coordonnées',
    position: 'Geographic position',
    photo: 'Photo',
    alert_success_text:
      'Thank you for your report - In case of danger, please call emergency services on 18',
    pollution: 'Pollution',
    security: 'Sécurité/Risques',
    echouage: 'Echouage',
    other: 'Autres',
    sea: 'Mer',
    beach: 'Plage',
    dead_animal: 'Animal mort',
    difficulty_animal: 'Animal en difficulté',
    waste: 'Déchets',
    odour: 'Odeur',
    medusa: 'Méduses',
    wood: 'Bois',
    fishing_net: 'Filet',
    hydrocarbon: 'Hydrocarbure',
    turtle: 'Tortue',
    bird: 'Oiseau',
    mammal: 'Mammifère marin',
    theme1: "Suspicious water discharge",
    theme2: 'Stranded animal',
    theme3: 'Démangeaisons',
    theme4: 'Hydrocarbures',
    theme5: 'Jellyfish/physalies',
    theme6: 'Drapeaux',
    theme7: "Kalilo application",
    theme99: 'Other',
    localiser: 'Locate',
    send: 'Send to',
    validate: 'Validate',
    close: 'Close',
  },
  // EO TODO
  tabs: {
    beaches: 'Beaches',
    alerts: "Alerts",
    news: "Info",
    favorites: "Favorites",
    more: "Settings",
    app: "Kalilo",
  },
  news: {
    header_title: "I get information",
    //title: "Bon à savoir",
    //subtitle: "L'agglomération met tout en oeuvre pour vous informer des bons gestes...",
    //show: "Afficher"
  },
  alerts: {
    header_title: "Alert",
    title: "Alert",
    subtitle: "Basque Country Community is making every effort to inform you about events on the coast.",
    tell_a_friend: "Inform"
  },
  beaches_list: {
    title: "Explore",
    favorites: "Favoris",
    search_beach: "Look for a beach",
    beaches: "beaches",
    beach: "beach"
  },
  beaches_filters: {
    page_title: "Filters",
    page_subtitle: 'What do you want to display?',
    beaches_title: "Beaches",
    beaches_favorites: "Favourites beaches",
    services_title: "Services",
    services_subtitle: "Display only the following services",
    show: "Display",
    service_1: "Accessibility",
    service_2: "Car park",
    service_3: "Aquatic activities",
    service_4: "Recreational clubs",
    service_5: "Toilets  \n showers",
    service_6: "Showers",
    service_8: "Restaurants",
    filter_result_1: 'beach meet your requirements',
    filter_result_2: ' beaches meet your requirements'
  },
  beaches_search: {
    title: "Search...",
    search: "Look for a beach"
  },
  beach_details : {
    tab_informations: "INFORMATION",
    tab_previsions: "WEATHER",
    tab_go: "GET THERE",
    oversight: "Surveillance",
    phone: "PHONE",
    more_info: 'More information',
    favorites: 'FAVORITES',
    pavillon_bleu: 'Pavillon Bleu Seal',
    demarche_qualite: 'Quality of bathing water certification',
    updated_on: 'Updated on',
    updated_today: 'Updated at',
    updated_at_time: 'at',
  },
  beaches_favorites : {
    title: "Favorites",
    beaches: "beaches",
    beach: "beach",
    intro: "Find here the list of your favourites beaches.",
    no_beach_title: "You don’t have a favourite beach!",
    no_beach_desc: "Add one or more beaches to your favourites list and receive information only for these beaches.",
    add: "Add"
  },
  settings : {
    title : "Settings",
    choose_language: "Your language",
    language: "Chosen language",
    choose_notifications: "Activate notifications",
    notifications: "In order to instantaneously receive any changes in conditions which could occur on your favourite beaches (flag colour, etc.), activate the notifications function.",
    informations: "App information",
    legal_notices: "Legal notices",
    credits: "Credits",
    about: "More information",
    help: "Help"
  },
  about : {
    page_title: "More information",
    description: 'Kalilo enables you to be kept updated on bathing conditions. However, your safety is above all related to your behaviour: as a priority you must go by the information provided by the lifeguard station. If you notice a difference between the colour of the flag flying on the beach and the flag indicated on the app, you must go by the colour of the flag flying on the beach.'
  },
  legal_noticies: {
    page_title: "Legal notices",
    description: `
Kalilo app is published by the Communauté d’agglomération Pays Basque (Basque Country Community)

Contact :
littoral@communaute-paysbasque.fr

Communication department :
communication@communaute-paysbasque.fr
    `,
    description2: `The personal data of internet users that is collected is exclusively for the use of the site editor and is processed in compliance with the provisions in French Law n° 78-17 of 6 January 1978, known as the Data Protection Act. The data processing manager is the editor, as defined above: no personal data is transferred or communicated to a third party.`
  },
  credits: {
    page_title: "Credits",
    source_title: 'Data sources',
    source_description: 'see informations',
    dev_title: "developments",
    design_ux_title: 'Design UX and UI :' ,
    design_title: 'Design',
    credits_title : 'Photo credits'
  },
  settings_language : {
    title : "Language",
    apply_button : "Apply",
    question: "Which language do you want to apply?"
  },
  days_name : {
    1 : "Monday",
    2 : "Tuesday",
    3 : "Wednesday",
    4 : "Thursday",
    5 : "Friday",
    6 : "Saturday",
    0 : "Sunday",
  },
  days_subname : {
    0: "Today",
    1: "Tomorrow",
    2: "Day after tomorrow"
  },
  creneau : {
    1: "Morning",
    2: "Midday",
    3: "Evening"
  },
  weather : {
    swell: "Swell",
    period: "Period",
    direction: "Direction",
    tides: "Tides",
    hm: "HIGH WATER",
    bm : "LOW WATER",
    coeff: "COEFFICIENT",
    wind: "Wind",
    water_temp: "WATER",
    uv: "UV"
  },
  location : {
    itinerary : "ITINERARY",
    txiktxak : "TRANSPORT",
  },
  map: {
    title : "Out of season",
    line_1: "Stay informed about sea  and local weather !",
    line_2: "Reminder: The bathing is not supervised, it is practiced at the risk and peril of the user."
  },
  map_pleine_saison: {
    title : "Keep informed",
  },
  map_hors_saison: {
    title : "Out of season",
    line_1: "Stay informed about sea  and local weather !",
    line_2: "Reminder: The bathing is not supervised, it is practiced at the risk and peril of the user."
  },
  map_all_beaches_closed: {
    title : "No lifeguard on duty",
    line_1: "There is currently no lifeguard on duty and bathing is at your own risk and peril.",
  },
  map_switch: {
    flag: 'Flag colours',
    quality: 'Bacteriological water quality',
    ostreopsis: 'Ostreopsis alert level',
  },
};

export default I18n_en;
